var map = {
	"./BankCard.svg": [
		53558,
		9258,
		3558
	],
	"./BankCardReceive.svg": [
		46685,
		9258,
		6685
	],
	"./KYB_lock.svg": [
		73426,
		9258,
		3426
	],
	"./Logo Perfroma.svg": [
		90699,
		9258,
		699
	],
	"./PaymentError.svg": [
		65994,
		9258,
		5994
	],
	"./PaymentSuccess.svg": [
		40217,
		9258,
		217
	],
	"./Right.svg": [
		20160,
		9258,
		160
	],
	"./SwapHorizontal.svg": [
		49139,
		9258,
		9139
	],
	"./alarm.svg": [
		20941,
		9258,
		941
	],
	"./arrow-back.svg": [
		2031,
		9258,
		2031
	],
	"./arrow-down-white.svg": [
		15046,
		9258,
		5046
	],
	"./arrow-down.svg": [
		46346,
		9258,
		6346
	],
	"./arrow-left-simple.svg": [
		70632,
		9258,
		632
	],
	"./arrow-left.svg": [
		58593,
		9258,
		8593
	],
	"./arrow-right-simple.svg": [
		19067,
		9258,
		9067
	],
	"./arrow-right.svg": [
		6092,
		9258,
		6092
	],
	"./bankCardSell.svg": [
		70678,
		9258,
		678
	],
	"./banner-coin.svg": [
		23998,
		9258,
		3998
	],
	"./business.svg": [
		26392,
		9258,
		6392
	],
	"./callout_error.svg": [
		20077,
		9258,
		77
	],
	"./canceled.svg": [
		7755,
		9258,
		7755
	],
	"./card.svg": [
		12536,
		9258,
		155
	],
	"./check.svg": [
		40030,
		9258,
		30
	],
	"./check_circle.svg": [
		50333,
		9258,
		333
	],
	"./chevron.svg": [
		54391,
		9258,
		4391
	],
	"./clear.svg": [
		5033,
		9258,
		5033
	],
	"./clearField.svg": [
		41423,
		9258,
		1423
	],
	"./close.svg": [
		67866,
		9258,
		7866
	],
	"./curvedLineAccount.svg": [
		33576,
		9258,
		3576
	],
	"./dots-menu.svg": [
		14986,
		9258,
		4986
	],
	"./dots.svg": [
		42058,
		9258,
		2058
	],
	"./email.svg": [
		88650,
		9258,
		8650
	],
	"./error.svg": [
		16676,
		9258,
		6676
	],
	"./errorModal.svg": [
		88815,
		9258,
		8815
	],
	"./eur.svg": [
		44738,
		9258,
		4738
	],
	"./exchange.svg": [
		5569,
		9258,
		5569
	],
	"./exit.svg": [
		84118,
		9258,
		1737
	],
	"./eye.svg": [
		38337,
		9258,
		8337
	],
	"./green_check.svg": [
		22522,
		9258,
		2522
	],
	"./hide_active.svg": [
		75427,
		9258,
		5427
	],
	"./ic-add-user.svg": [
		13980,
		9258,
		3980
	],
	"./ic-alarm-white.svg": [
		80230,
		9258,
		230
	],
	"./ic-alarm.svg": [
		56842,
		9258,
		6842
	],
	"./ic-arrow-down.svg": [
		81167,
		9258,
		1167
	],
	"./ic-arrow-exit.svg": [
		22527,
		9258,
		2527
	],
	"./ic-arrow-horizontal.svg": [
		49251,
		9258,
		9251
	],
	"./ic-arrow-new-tab-light.svg": [
		12714,
		9258,
		2714
	],
	"./ic-arrow-new-tab.svg": [
		69409,
		9258,
		9409
	],
	"./ic-arrow-switch-x1,5.svg": [
		49092,
		9258,
		9092
	],
	"./ic-arrow-switch.svg": [
		73163,
		9258,
		3163
	],
	"./ic-arrow-up-md.svg": [
		58042,
		9258,
		8042
	],
	"./ic-arrow-up-right.svg": [
		99537,
		9258,
		9537
	],
	"./ic-attention.svg": [
		93295,
		9258,
		3295
	],
	"./ic-bell-notifications.svg": [
		83623,
		9258,
		3623
	],
	"./ic-business.svg": [
		79901,
		9258,
		9901
	],
	"./ic-calendar.svg": [
		83337,
		9258,
		3337
	],
	"./ic-card.svg": [
		82145,
		9258,
		2145
	],
	"./ic-chat.svg": [
		84973,
		9258,
		4973
	],
	"./ic-check-1.svg": [
		47227,
		9258,
		7227
	],
	"./ic-check-double.svg": [
		53893,
		9258,
		3893
	],
	"./ic-check-paid-performa.svg": [
		51993,
		9258,
		1993
	],
	"./ic-check-paid.svg": [
		39752,
		9258,
		9752
	],
	"./ic-check.svg": [
		3329,
		9258,
		3329
	],
	"./ic-chevron-right.svg": [
		25229,
		9258,
		5229
	],
	"./ic-circle-icon.svg": [
		10467,
		9258,
		467
	],
	"./ic-close.svg": [
		4349,
		9258,
		4349
	],
	"./ic-copy copy.svg": [
		49871,
		9258,
		9871
	],
	"./ic-copy-1.5.svg": [
		16377,
		9258,
		6377
	],
	"./ic-copy-performa.svg": [
		89721,
		9258,
		9721
	],
	"./ic-copy.svg": [
		96648,
		9258,
		6648
	],
	"./ic-corner-small-up.svg": [
		95648,
		9258,
		5648
	],
	"./ic-cross-performa.svg": [
		31318,
		9258,
		1318
	],
	"./ic-crypto-1.5.svg": [
		13093,
		9258,
		3093
	],
	"./ic-delete.svg": [
		30194,
		9258,
		194
	],
	"./ic-detail_modal_excel.svg": [
		62226,
		9258,
		2226
	],
	"./ic-document-copy.svg": [
		63450,
		9258,
		3450
	],
	"./ic-document-gray.svg": [
		39900,
		9258,
		9900
	],
	"./ic-document-paper.svg": [
		36649,
		9258,
		6649
	],
	"./ic-document-pdf.svg": [
		13413,
		9258,
		3413
	],
	"./ic-document-xls.svg": [
		97176,
		9258,
		7176
	],
	"./ic-document-xlsx.svg": [
		23936,
		9258,
		3936
	],
	"./ic-document.svg": [
		14488,
		9258,
		4488
	],
	"./ic-download-brand.svg": [
		90519,
		9258,
		519
	],
	"./ic-download-gray.svg": [
		6989,
		9258,
		6989
	],
	"./ic-download.svg": [
		83687,
		9258,
		3687
	],
	"./ic-dublicate.svg": [
		85168,
		9258,
		5168
	],
	"./ic-erase-input-close.svg": [
		99143,
		9258,
		9143
	],
	"./ic-error.svg": [
		6623,
		9258,
		6623
	],
	"./ic-essentials-chat copy.svg": [
		78210,
		9258,
		8210
	],
	"./ic-essentials-chat.svg": [
		25735,
		9258,
		5735
	],
	"./ic-excel.svg": [
		50492,
		9258,
		492
	],
	"./ic-exchange.svg": [
		39788,
		9258,
		9788
	],
	"./ic-fast.svg": [
		58425,
		9258,
		8425
	],
	"./ic-filter-cancel.svg": [
		54696,
		9258,
		4696
	],
	"./ic-info-tooltip.svg": [
		44405,
		9258,
		4405
	],
	"./ic-key.svg": [
		8552,
		9258,
		8552
	],
	"./ic-lines-menu.svg": [
		30016,
		9258,
		16
	],
	"./ic-link.svg": [
		16783,
		9258,
		6783
	],
	"./ic-loans.svg": [
		29284,
		9258,
		9284
	],
	"./ic-lock-gray.svg": [
		51554,
		9258,
		1554
	],
	"./ic-lock.svg": [
		4298,
		9258,
		4298
	],
	"./ic-mail.svg": [
		11558,
		9258,
		1558
	],
	"./ic-mass-payments-check.svg": [
		52338,
		9258,
		2338
	],
	"./ic-mass-payments-error.svg": [
		8032,
		9258,
		8032
	],
	"./ic-mass-payments-mail.svg": [
		90847,
		9258,
		847
	],
	"./ic-mass-payments-ready.svg": [
		87343,
		9258,
		7343
	],
	"./ic-mass-payments-wallet.svg": [
		52677,
		9258,
		2677
	],
	"./ic-new-link.svg": [
		89968,
		9258,
		9968
	],
	"./ic-news.svg": [
		35510,
		9258,
		5510
	],
	"./ic-pause.svg": [
		18059,
		9258,
		8059
	],
	"./ic-pay.svg": [
		75015,
		9258,
		5015
	],
	"./ic-pen-edit.svg": [
		26741,
		9258,
		6741
	],
	"./ic-pen.svg": [
		20916,
		9258,
		916
	],
	"./ic-percentage.svg": [
		30379,
		9258,
		379
	],
	"./ic-plus.svg": [
		23211,
		9258,
		3211
	],
	"./ic-power.svg": [
		51070,
		9258,
		1070
	],
	"./ic-profile-add.svg": [
		10636,
		9258,
		636
	],
	"./ic-qr-scan-x1,5.svg": [
		96497,
		9258,
		6497
	],
	"./ic-qr-scan.svg": [
		79420,
		9258,
		9420
	],
	"./ic-qr-white.svg": [
		91214,
		9258,
		1214
	],
	"./ic-qr.svg": [
		86434,
		9258,
		6434
	],
	"./ic-safe.svg": [
		81860,
		9258,
		1860
	],
	"./ic-search.svg": [
		44663,
		9258,
		4663
	],
	"./ic-sepa-full.svg": [
		33984,
		9258,
		3984
	],
	"./ic-settings-performa.svg": [
		25101,
		9258,
		5101
	],
	"./ic-settings.svg": [
		54732,
		9258,
		4732
	],
	"./ic-setup-arrow.svg": [
		42474,
		9258,
		2474
	],
	"./ic-sort-table.svg": [
		93892,
		9258,
		3892
	],
	"./ic-swap.svg": [
		34222,
		9258,
		4222
	],
	"./ic-telegram.svg": [
		31918,
		9258,
		1918
	],
	"./ic-tether.svg": [
		19279,
		9258,
		9279
	],
	"./ic-time-circle.svg": [
		84869,
		9258,
		4869
	],
	"./ic-time.svg": [
		53560,
		9258,
		3560
	],
	"./ic-tuning.svg": [
		2536,
		9258,
		2536
	],
	"./ic-user.svg": [
		69642,
		9258,
		9642
	],
	"./ic-verified.svg": [
		22899,
		9258,
		2899
	],
	"./ic-wallet-income.svg": [
		10428,
		9258,
		428
	],
	"./ic-wallet-index.svg": [
		84055,
		9258,
		4055
	],
	"./ic-whatsapp.svg": [
		67377,
		9258,
		7377
	],
	"./ic_at_dog_mail.svg": [
		65313,
		9258,
		5313
	],
	"./ic_delete-gray.svg": [
		98620,
		9258,
		8620
	],
	"./ic_delete.svg": [
		45592,
		9258,
		5592
	],
	"./ic_delete_brand.svg": [
		61202,
		9258,
		1202
	],
	"./ic_delete_light.svg": [
		30269,
		9258,
		269
	],
	"./ic_delete_performa.svg": [
		40883,
		9258,
		883
	],
	"./ic_duplicate.svg": [
		94364,
		9258,
		4364
	],
	"./ic_edit_change.svg": [
		45552,
		9258,
		5552
	],
	"./ic_history.svg": [
		7535,
		9258,
		7535
	],
	"./ic_lightning.svg": [
		5133,
		9258,
		5133
	],
	"./ic_link.svg": [
		30717,
		9258,
		717
	],
	"./ic_list.svg": [
		18065,
		9258,
		8065
	],
	"./ic_rocket_gray.svg": [
		37353,
		9258,
		7353
	],
	"./ic_sepa.svg": [
		29004,
		9258,
		9004
	],
	"./ic_settings_email.svg": [
		29763,
		9258,
		9763
	],
	"./ic_settings_telegram.svg": [
		37260,
		9258,
		7260
	],
	"./ic_smile.svg": [
		13655,
		9258,
		3655
	],
	"./ic_swift.svg": [
		48474,
		9258,
		8474
	],
	"./ic_wallet.svg": [
		42298,
		9258,
		2298
	],
	"./icon-close-modal.svg": [
		79282,
		9258,
		9282
	],
	"./iconChevron.svg": [
		82894,
		9258,
		2894
	],
	"./iconNoData.svg": [
		26556,
		9258,
		6556
	],
	"./iconTriangle.svg": [
		81105,
		9258,
		1105
	],
	"./icon_info.svg": [
		92204,
		9258,
		2204
	],
	"./icon_mail_brand.svg": [
		48175,
		9258,
		8175
	],
	"./logo text.svg": [
		11208,
		9258,
		1208
	],
	"./mc.svg": [
		72406,
		9258,
		2406
	],
	"./mir.svg": [
		64838,
		9258,
		4838
	],
	"./new-exchange.svg": [
		29654,
		9258,
		9654
	],
	"./options.svg": [
		40524,
		9258,
		524
	],
	"./paste.svg": [
		67036,
		9258,
		4655
	],
	"./profile.svg": [
		83341,
		9258,
		3341
	],
	"./profile_KYB_pending.svg": [
		47934,
		9258,
		7934
	],
	"./profile_KYB_reject.svg": [
		45368,
		9258,
		5368
	],
	"./purple_qr.svg": [
		39718,
		9258,
		9718
	],
	"./qr-code-withdraw.svg": [
		53770,
		9258,
		3770
	],
	"./qr_code_logo.svg": [
		18253,
		9258,
		8253
	],
	"./qr_code_wallet.svg": [
		53671,
		9258,
		3671
	],
	"./receiving_dropdown.svg": [
		48912,
		9258,
		8912
	],
	"./return-arrow.svg": [
		12008,
		9258,
		2008
	],
	"./rub.svg": [
		67349,
		9258,
		7349
	],
	"./sbp.svg": [
		41331,
		9258,
		1331
	],
	"./search.svg": [
		72166,
		9258,
		2166
	],
	"./success.svg": [
		84607,
		9258,
		4607
	],
	"./success_light.svg": [
		34798,
		9258,
		4798
	],
	"./swap.svg": [
		48975,
		9258,
		8975
	],
	"./sync_logo.svg": [
		91823,
		9258,
		1823
	],
	"./table-filter.svg": [
		12753,
		9258,
		2753
	],
	"./telegram.svg": [
		82319,
		9258,
		2319
	],
	"./top-arrow.svg": [
		97963,
		9258,
		7963
	],
	"./usd.svg": [
		31742,
		9258,
		1742
	],
	"./visa.svg": [
		79933,
		9258,
		9933
	],
	"./withdrawToEmail.svg": [
		92449,
		9258,
		2449
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 65956;
module.exports = webpackAsyncContext;